import { useMemo } from 'react';

import { wallsApi } from '@walls/services/wallsApi';
import type { WallBoard, WallCard } from '@walls/store';
import { isImageCard } from '../utils/cardDisplay';

export function useCardImage(board: WallBoard, card: WallCard) {
  return useMemo(() => {
    if (!isImageCard(card)) {
      return null;
    }

    return `${wallsApi.getCardImageUrl(board.id, card.id)}?random=${card.created ?? card.id}`;
  }, [board.id, card]);
}
